/**
 * s3 (파일 업로드) orval 래퍼
 *
 * S3 관련 API는 presigned URL 로직 등 특수 처리가 필요하므로
 * customInstance를 직접 사용한다.
 */
import { addPrefixToFileName } from "@erp/shared/utils/file/file-name";
import { customInstance } from "../custom-instance";
import axios from "axios";
// ── Enum ──
export var S3_FOLDER;
(function (S3_FOLDER) {
    S3_FOLDER["USER_PROFILE"] = "user";
    S3_FOLDER["PRODUCT_PHOTO"] = "product/photo";
    S3_FOLDER["INBOUND_INSPECTION_REPORT"] = "inbound/inspectionReport";
    S3_FOLDER["INBOUND_RECEIVING_INSPECTION"] = "inbound/receivingInspection";
    S3_FOLDER["INBOUND_ETC"] = "inbound/etc";
    S3_FOLDER["OUTBOUND_INSPECTION_REPORT"] = "outbound/inspectionReport";
    S3_FOLDER["OUTBOUND_ETC"] = "outbound/etc";
    S3_FOLDER["ESTIMATE_APPROVAL"] = "estimate/approval";
    S3_FOLDER["ESTIMATE_BLUEPRINT"] = "estimate/blueprint";
    S3_FOLDER["ESTIMATE_OBTAIN"] = "estimate/obtain";
    S3_FOLDER["ESTIMATE_ETC"] = "estimate/etc";
    S3_FOLDER["OBTAIN_APPROVAL"] = "obtain/approval";
    S3_FOLDER["OBTAIN_BLUEPRINT"] = "obtain/blueprint";
    S3_FOLDER["OBTAIN_OBTAIN"] = "obtain/obtain";
    S3_FOLDER["OBTAIN_ETC"] = "obtain/etc";
    S3_FOLDER["PURCHASE_ESTIMATE"] = "purchase/estimate";
    S3_FOLDER["PURCHASE_PRODUCT_IMAGE"] = "purchase/productImage";
    S3_FOLDER["ORDER_CONFIRMATION"] = "order/orderConfirmation";
    S3_FOLDER["ORDER_BUSINESS_REGISTRATION"] = "order/businessRegistration";
    S3_FOLDER["ORDER_BANKBOOK"] = "order/bankbook";
    S3_FOLDER["ORDER_BILL"] = "order/bill";
    S3_FOLDER["ORDER_CONFIRM_TRANSFER"] = "order/confirmTransfer";
    S3_FOLDER["PAYMENT_PHOTO"] = "expenditure-resolution/paymentPhoto";
})(S3_FOLDER || (S3_FOLDER = {}));
// ── API 함수 ──
export async function getImageUrl(key) {
    const data = await customInstance({
        url: "/uploads/view-url",
        method: "GET",
        params: { key },
    });
    return data.url;
}
export async function downloadFileFromS3(key, fileName = "파일_이름을_넣어주셔야합니다.pdf") {
    if (!key)
        throw new Error("파일 키가 없습니다.");
    return customInstance({
        url: "/uploads/download-url",
        method: "GET",
        params: { key, fileName },
    });
}
export async function uploadFileToS3(file, folder, useOriginFileName = false) {
    if (!file)
        throw new Error("파일이 없습니다.");
    const fileName = useOriginFileName
        ? file.name
        : addPrefixToFileName(file.name);
    const fileNameWithPath = folder ? `${folder}/${fileName}` : fileName;
    const contentType = file.type || "application/octet-stream";
    // 1. Presigned URL 요청
    const uploadURL = await customInstance({
        url: "/uploads/presigned-url",
        method: "GET",
        params: {
            fileName: fileNameWithPath,
            fileType: contentType,
        },
    });
    // 2. Presigned URL로 직접 S3 업로드 (auth가 없어야 함)
    await axios.put(uploadURL, file, {
        headers: {
            "Content-Type": contentType,
        },
    });
    return fileNameWithPath;
}
export async function deleteFileToS3(key) {
    return customInstance({
        url: "/uploads/s3",
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        data: { fileName: key },
    });
}
// ── SDK 객체 ──
export const s3Api = {
    getImageUrl,
    downloadFileFromS3,
    uploadFileToS3,
    deleteFileToS3,
};
